import BrowseApplication from '../../modules/browse/frontend/application.coffee';

import PageApplication from '../../modules/page/frontend/application.coffee';

PageApplication.initialize();
BrowseApplication.initialize();
